import { gql } from "@apollo/client"
import { SB_ACCOUNTS_FRAGMENT } from "../../fragments"

const GET_SB_ACCOUNTS = gql`
  ${SB_ACCOUNTS_FRAGMENT}

  query($input: SBAccountsInput!) { 
    sbAccounts(input: $input) {
      ...SBAccountFields
    }
  } 
`

export { GET_SB_ACCOUNTS }